import { DRAFT_CLOSE_ACTION } from '../Draft.constants'

export function getDraftCloseActionSelectModalOptions({
  discardLabelKey,
  saveLabelKey,
  t,
}) {
  return [
    { id: DRAFT_CLOSE_ACTION.saveDraft, label: t(saveLabelKey) },
    { id: DRAFT_CLOSE_ACTION.discardDraft, label: t(discardLabelKey) },
  ]
}
